import { render, staticRenderFns } from "./CardAtividades.vue?vue&type=template&id=63e97753"
import script from "./CardAtividades.vue?vue&type=script&lang=js"
export * from "./CardAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports